module.exports = __webpack_public_path__ + "img/ct-at-solid.2fea6efc.svg";